import { IPagination } from '../../../domain/jplist/interfaces';
import { IIndexable } from '../../../domain/interfaces';
import { IPurchased } from '../../membership/purchased-products/interfaces';
import { ReactNode } from 'react';
import { CompareTypeEnum } from '../compare/compare-type-enum';

export interface IListContentProps {
    products: IListItem[],
    width: number,
    hasPanels?: boolean,
}

export enum ListProductReferrer {
    ListPage = 0,
}

export interface IListProductProps {
    product: IListItem,
    isGoogleShoppingFeed?: boolean,
    removeImgLink?: boolean,
    removeTitleLink?: boolean,
    isAccountPage?: boolean,
    additionalContent?: any,
    children?: ReactNode,

    // visibility properties
    isTaglineHidden?: boolean,
    isPriceAreaHidden?: boolean,
    isRatingHidden?: boolean,
    isButtonAndNoteHidden?: boolean,
    isIncludedInHidden?: boolean,
    isSbsTextHidden?: boolean,

    // compare properties
    // https://wavesaudio.atlassian.net/browse/DSWEB-3160
    // https://wavesaudio.atlassian.net/browse/DSWEB-3285
    isCompareVisible?: boolean,
    compareCallback?: Function,
    compareType?: CompareTypeEnum,

    // price visibility properties
    isPriceFirstRowHidden?: boolean,
    isFirstMerchRowHidden?: boolean,
    isPriceSecondRowHidden?: boolean,
    isPriceThirdRowHidden?: boolean,
    isPriceDiscountBadgeHidden?: boolean,
    isPriceClockHidden?: boolean,
    isExpectedShippingHidden?: boolean,

    // other visibility properties
    useSrcDetails?: boolean,
    priceCustomText?: string,
    imageHeight?: string,
    disableImageLazy?: boolean;

    listName?: string,
    classes?: string,

    // https://wavesaudio.atlassian.net/browse/MRKT-25058
    // old:34, yellow-sbs:33, perpetual-link:33
    buttonsABCDAbTest?: string,
    referrer?: ListProductReferrer,

    // https://wavesaudio.atlassian.net/browse/DSWEB-5397
    showSuperSaleBadge?: boolean;
}

export interface IListItem {
    nodeGUID: string,
    nodeID: number,

    documentName: string,
    documentNameCapitalLettersNum: number,
    documentNameSmallLettersNum: number,
    documentID: number,

    documentUrlPath: string,
    documentPageDescription: string,
    tagline: string,
    preview: string,
    thumb: string,
    msrp: number,
    skuPrice: number,
    discount: number,
    mainOrder: number,
    skuid: number,
    skuEnabled: boolean,
    skuNumber: string,
    note: string,

    departmentID: number,
    skuDepartmentID?: number,

    couponCode: string,
    couponCampaignID: number,
    couponPrice: number,

    isProductOptions: boolean,
    variantsMinimalPrice: number,
    isVariantsPriceSame: boolean,
    isPreorder: boolean,
    optionName?: string,

    reviewsTotal: number,
    rating: number,
    saleEndDate?: Date,

    badgeText: string,
    badgeClass: string,

    minPrice?: number|string, // string === 'fake'
    fixedPosition?: string,

    withCouponEnabled?: boolean,
    isProductVisible?: boolean,
    isSamePrice?: boolean,
    expectedShipping?: string|null,
    isProductFadeOut?: boolean,
    isVisible?: boolean,
    title?: string,
    numberOfLessons?: number|string,
    courseDurationHours?: number|string,
    numberOfPlugins?: number|string,

    sbsIncludedIn?: number,
    isWishlist?: boolean,
    resultSetType?: string;
    freeForWCA?: boolean,

    // https://wavesaudio.atlassian.net/browse/MRKT-25058
    // old:34, yellow-sbs:33, perpetual-link:33
    buttonsABCDAbTest?: 'old',
    referrer?: ListProductReferrer,
}

export interface IActiveTier {
    itemOrder: number,
    tierName: string,
}

export interface StateInterface extends IIndexable{
    productsInitial: IListItem[],
    products: IListItem[],
    loading: boolean;

    // filter
    filterTerm: string,
    filterProperty: string,
    filterPlaceholderText: string,

    // pagination
    pagination: IPagination|null,
    currentPage: number,
    itemsPerPage: number,
    paginationRange: number,

    // sort
    sortType: string, // text|number|datetime
    sortProperty: string,
    sortOrder: string, // asc or desc

    // theme (layout)
    layoutMode: string, // grid|list

    // counters: (new Date()).getTime()
    localTime: number,

    purchased: IPurchased|null,
    hideMyProducts: boolean,
    showLoginPage: boolean,

    // https://dev13.waves.com/my-recommended-products
    isRecommended: boolean,

    // https://wavesaudio.atlassian.net/browse/DSWEB-3146
    allProductsToCartBtnLink: string,

    // https://wavesaudio.atlassian.net/browse/DSWEB-3160
    // https://wavesaudio.atlassian.net/browse/DSWEB-3285
    isCompareVisible: boolean,
    isComparePopupVisible: boolean,
    compareType: CompareTypeEnum,
    compareServersDocIdList: number[],

    // https://wavesaudio.atlassian.net/browse/DSWEB-5397
    superSaleAbTest: string,
}

export interface IPanelProps {
    width?: number,
}

export enum abtest_ProductListPricingAreaVariants {
    old = 0,
    yellow_sbs = 1,
    perpetual_link = 2
}
export enum abtest_PagesType {
    list = 0,
    product = 1
}